import React, { useState, useRef, useEffect } from "react";
import localData from "../../../localData";
import { useGlobalContext } from "../../../context";
import { Field } from "../../";
import emailjs from "@emailjs/browser";

export default function Contact() {
    const { react, sticker } = localData.images;
    const { send, stickerSVG, closer, facebook2, linkedin, twitter, github, instagram, email, phone, location } =
        localData.svgs;

    const [form, setForm] = useState([
        {
            name: "name",
            value: "",
            label: "name",
            type: "string",
            message: "",
            required: true,
            placeholder: "John Doe",
            invalidFeedback: false,
        },
        {
            name: "email",
            value: "",
            label: "email",
            type: "email",
            message: "",
            invalidFeedback: false,
            placeholder: "john@doe.com",
            required: true,
        },
        {
            name: "message",
            value: "",
            label: "message",
            type: "string",
            message: "",
            required: true,
            placeholder: "Type your message",
            invalidFeedback: false,
        },
    ]);

    const [alert, setAlert] = useState({
        type: "success",
        message: "",
    });
    const [alertTimeout, setAlertTimeout] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { globalOnSubmitHandler, globalOnChangeHandler } = useGlobalContext();

    const createAlert = ({ success, message }) => {
        setAlert({ ...alert, message, type: success ? "dark" : "danger" });
        clearTimeout(alertTimeout);
        setAlertTimeout(setTimeout(() => setAlert({ ...alert, message: "" }), 3000));
    };

    const onSubmitHandler = (e) => {
        e.preventDefault();
        const { decodedForm } = globalOnSubmitHandler(form, setForm);

        if (!decodedForm) return setIsSubmitted(true);

        // setIsLoading(true);

        // fetch.login(decodedForm, (err, data) => {
        //     createAlert(data || err)
        //     if (data) {
        //         setTimeout(() => {
        //             auth.login(data);
        //             setAuth({ ...auth, state: auth.getState() });
        //         }, 3000);
        //     }

        //     setIsLoading(false);
        //     setIsSubmitted(false);
        // });
        sendEmail();
    };

    const onChangeHandler = (e, field) => {
        globalOnChangeHandler(e, field, form, setForm);
    };

    const myForm = useRef();

    const sendEmail = () => {
        emailjs.sendForm("service_rgu8s0c", "template_1cudbuw", myForm.current, "uSh9jyvukgjv_t7Bv").then(
            (result) => {
                createAlert({ success: true, message: "dark" });
            },
            (error) => {
                console.log(error.text);
            }
        );
    };

    const getSenderName = () =>{
        if(!myForm.current) return
        const name =  myForm.current.querySelectorAll(".form-control")[0].value
        return  name.charAt(0).toUpperCase() + name.slice(1);
    }

    return (
        <section className="contact" id="contact" data-lazy-block>
            <div className="container-fluid">
                <h2 className="contact-title" data-lazy="fade">
                    contacts
                </h2>
                <div className="contact-center">
                    <form className="form" ref={myForm}>
                        {form.map((field, index) => (
                            <Field key={index} {...{ field, ...field, isSubmitted, onChangeHandler }} />
                        ))}
                        <div className="wrapper">
                            <div className="form-group">
                                <label htmlFor="message" className="form-label">
                                    message
                                </label>
                                <textarea
                                    name="message"
                                    id="message"
                                    cols="30"
                                    rows="6"
                                    className="form-control"
                                    type="string"
                                    value={form[2].value}
                                    placeholder={form[2].placeholder}
                                    onChange={(e) => onChangeHandler(e, form[2])}
                                ></textarea>
                                <div
                                    className={`alert alert-danger d-${
                                        form[2].invalidFeedback && isSubmitted ? "block" : "none"
                                    }`}
                                >
                                    {form[2].message}
                                </div>
                                <div
                                    className={`alert alert-success d-${
                                        !form[2].invalidFeedback && isSubmitted ? "block" : "none"
                                    }`}
                                >
                                    looks good
                                </div>
                            </div>

                            <button
                                className="btn submit-btn submit-btn-warning"
                                onClick={(e) => e.preventDefault()}
                                onMouseDown={(e) => onSubmitHandler(e)}
                            >
                                <div className="btn-inner">send </div> <span className="endIcon">{send}</span>
                            </button>
                        </div>
                        <div className={`alert alert-danger alert-popup ${alert.message ? "show" : ""}`}>
                            <span className="alert-content">
                                Thanks for submitting {getSenderName()}!
                            </span>
                            <div className="alert-closer" onClick={() => setAlert({ ...alert, message: "" })}>
                                {closer}
                            </div>
                        </div>
                    </form>

                    <div className="links">
                        <ul className="details">
                            <a href="#/" className="details-link email">
                                <span>{email}</span>
                                karenwerner09@gmail.com
                            </a>
                            {/* <a href="tel:+123 456 7890" className="details-link email">
                                <span>{phone}</span>
                                +123 456 7890
                            </a> */}
                            <a href="#/" className="details-link email">
                                <span>{location}</span>
                                Yerevan, Armenia
                            </a>
                        </ul>
                        <ul className="social-media">
                            <a href="https://www.facebook.com/profile.php?id=100077074302853" target='_blank' className="social-media-link">
                                {facebook2}
                            </a>
                            <a href="https://twitter.com/Karen42775967" target='_blank' className="social-media-link">
                                {twitter}
                            </a>
                            <a href='https://www.linkedin.com/in/karenwerner09/' target='_blank' className="social-media-link">
                                {linkedin}
                            </a>
                            <a href="https://github.com/Karen09w" target='_blank' className="social-media-link">
                                {github}
                            </a>
                            <a href="https://www.instagram.com/karenwerner09/" target='_blank' className="social-media-link">
                                {instagram}
                            </a>
                        </ul>
                    </div>

                    <div className="sticker">
                        {/* <img src={sticker} alt="" /> */}
                        {stickerSVG}
                    </div>
                </div>
            </div>
            <p className="contact-bottom">
                made with React <img src={react} /> by Karen Werner
            </p>
        </section>
    );
}
